import { Box, Container } from "@radix-ui/themes"
import { UserWithManagerships, ManageableForAdmin } from "@/types/shared"
import ManagershipRow from "./ManagershipRow"
import { useState } from "react"

interface ManagershipsTableProps {
  users: UserWithManagerships[]
  assignable: ManageableForAdmin[]
  endpoint: string
  paramKey: string
  placeholder: string
  emptyMessage: string
}

export default function ManagershipsTable({
  users,
  assignable,
  endpoint,
  paramKey,
  placeholder,
  emptyMessage,
}: ManagershipsTableProps) {
  const [refreshKey, setRefreshKey] = useState(0)

  const handleUpdate = () => {
    setRefreshKey((k) => k + 1)
  }

  return (
    <Container size="4">
      <Box>
        {users.map((user) => (
          <ManagershipRow
            key={`${user.id}-${refreshKey}`}
            user={user}
            assignable={assignable}
            endpoint={endpoint}
            paramKey={paramKey}
            placeholder={placeholder}
            emptyMessage={emptyMessage}
            onUpdate={handleUpdate}
          />
        ))}
      </Box>
    </Container>
  )
}
